const baseURLApi = process.env.VUE_APP_API_URL;
const testMode = process.env.VUE_APP_TEST_MODE === 'true';
const sitePrefix = process.env.VUE_APP_SITE_PREFIX;
const cryptoType = process.env.VUE_APP_CRYPTO_TYPE;

const config = {
    baseURLApi,
    testMode,
    sitePrefix,
    cryptoType,
    remote: "https://flatlogic-node-backend.herokuapp.com",
    isBackend: false,
    auth: {
        email: 'admin@flatlogic.com',
        password: 'password'
    },
    app: {
        sidebarTransitionTime: 300, //ms
        colors: {
            sidebar: "#002B49",
            navbar: "#ffffff",
            primary: "#005792",
            secondary: "#798892",
            success: "#21AE8C",
            info: "#1A86D0",
            warning: "#FDA700",
            danger: "#FD5F00",
            inverse: "#002B49",
            textColor: "#495057",
            gray: "#D7DFE6"
        },
        themeColors: [
            ['default','#002B49'],
            ['white', '#FFFFFF'],
            ['first','#004472'],
            ['second','#e9ebef'],
            ['third','#d1e7f5'],
            ['fourth','#ccdde9'],
            ['fifth','#d6dfe6'],
            ['sixth','#13191d'],
            ['seventh','#20ae8c'],
        ],
        chartColors: {
            axisColor: '#8EA1AB'
        }
    }
};
export default config;
